import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiEnum, HttpDataService } from './http-data.service';

import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { SKIP_GLOBAL_LOADER } from '../interceptors/loader.interceptor';
import { DomSanitizer } from '@angular/platform-browser';
import { JwtHelperService } from "@auth0/angular-jwt";
import { MsalService } from '@azure/msal-angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { ContextLocationViewModel } from '../models/main/context-location.model';
import { UserProfileViewModel } from '../models/main/user-profile.model';
import { UserProfileStore } from '../stores/user-profile.store';
import { GlobalService } from './global.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  helper = new JwtHelperService();

  isIframe = false;
  loggedIn = false;
  currentUrl = '';
  recordUrl: boolean = true;
  constructor(
    private readonly httpDataService: HttpDataService,
    private readonly msalService: MsalService,
    private readonly userProfileStore: UserProfileStore,
    private readonly http: HttpClient,
    private readonly sanitizer: DomSanitizer,
    private readonly globalService: GlobalService,
    private readonly notificationService: NotificationService,
    private readonly _translateService: TranslateService
  ) { }

  initializeAuth(): Promise<any> {
    const promise: any = new Promise(async (resolve, reject) => {
      this.isIframe = window !== window.parent && !window.opener;

      this.checkoutAccount().then((result) => {
        resolve(true);

        // this.msalService.handleRedirectCallback((authError) => {
        //   if (authError) {
        //     return;
        //   }
        // });

        // this.msalService.setLogger(
        //   new Logger((logLevel, message, piiEnabled) => { }, {
        //     correlationId: CryptoUtils.createNewGuid(),
        //     piiLoggingEnabled: false,
        //   })
        // );
      })
    });
    return promise;
  }

  async checkoutAccount(): Promise<any> {
    this.loggedIn = this.msalService.instance["browserStorage"].clientId;

    if (this.loggedIn) {
      const account = this.msalService.instance.getActiveAccount();
      return await this.logIn();
    }
  }

  async logIn(): Promise<any> {
    
    
    const promise: any = new Promise((resolve, reject) => {
      this.httpDataService
        .get$<UserProfileViewModel>(ApiEnum.API_ROOT, environment.endpoint.settings.user)
        .subscribe(
          (user) => {
            if (user && user.username && user.username.length > 0) {
              this.userProfileStore.setUserProfile(user);
              resolve(true);
            }
            else {
              reject(true);
              this.logOut();
            }
          },
          (error) => {
            this.notificationService.showError(this._translateService.instant("shared.errorAuthenticationExpired"));
            reject(true)
          }
        );
    })
    return promise;
  }

  saveUserProfile(user: UserProfileViewModel): any {
    return this.httpDataService.put$<any>(ApiEnum.API_ROOT, environment.endpoint.settings.user, user)
      .pipe(
        map((userProfile) => {
          return userProfile;
        }),
        retry(3),
        catchError(this.httpDataService.handleError<any[]>('userDb'))
      );
  }

  setUserProfile(user: UserProfileViewModel) {
    // Los permisos reales (profiles/roles/token) provienen del login contra el backend
    // (/settings/user). Un guardado de preferencias (idioma, dark mode, modo optimizado…) NO
    // debe alterarlos. Antes este método ignoraba `user` y forzaba un perfil Admin ficticio, lo
    // que escalaba la UI a Admin tras tocar cualquier ajuste; se conservan los de la sesión.
    const actual = this.userProfileStore.getUserProfile();
    if (actual) {
      user.profiles = actual.profiles;
      user.roles = actual.roles;
      user.token = user.token || actual.token;
    }

    this.userProfileStore.setUserProfile(user);
  }

  private headers() {
    let keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      keys.push(localStorage.key(i));
    }
    //keys = keys.filter(x => x.startsWith("msal.") && x.endsWith(".idtoken"));
    keys = keys.filter(x => x.indexOf(`-idtoken-${  environment.azureAD.clientId}`) > -1);

    let token = "";

    //token = localStorage.getItem(keys.length > 0 ? keys[0] : 'msal.idtoken');
    token = JSON.parse(localStorage.getItem(keys.length > 0 ? keys[0] : 'msal.idtoken')).secret

    let userProfile;

    //token = localStorage.getItem(keys.length > 0 ? keys[0] : 'msal.idtoken');

    let headers = new HttpHeaders();

    headers = headers.set("Authorization", token);

    return headers;
  }

  getMyPhoto(): Observable<Blob> {
    const requestUrl = 'https://graph.microsoft.com/v1.0/me/photo/$value'
    return this.http.get(requestUrl, { headers: this.headers(), responseType: "blob" }).pipe(map(result => {
      return result;
    }));
  }

  getUserPhoto(user: string): Observable<Blob> {
    // Carga decorativa e incremental (avatares): no debe disparar el loader global.
    const requestUrl = `https://graph.microsoft.com/v1.0/users/${  user  }/photo/$value`
    return this.http.get(requestUrl, {
      headers: this.headers(),
      responseType: "blob",
      context: new HttpContext().set(SKIP_GLOBAL_LOADER, true),
    }).pipe(map(result => {
      return result;
    }));
  }

  /** Datos de directorio (Microsoft Graph): oficina, departamento, etc. Para el panel de perfil. */
  getMyDirectoryInfo(): Observable<any> {
    const requestUrl = 'https://graph.microsoft.com/v1.0/me?$select=officeLocation,preferredLanguage,jobTitle,department';
    return this.http.get<any>(requestUrl, { headers: this.headers() });
  }

  logOut() {
    this.msalService.logout();
  }

  isLoggedIn(): boolean {
    this.loggedIn = !!this.msalService.instance.getActiveAccount();
    return this.loggedIn;
  }

  validateToken(token: string, params: any) {
    let result = false;
    let decodedToken;
    let profileUser;

    const locations: ContextLocationViewModel[] = JSON.parse(atob(localStorage.getItem("location")));
    let filterLocation: ContextLocationViewModel[] = [];
    let typeFilter = "";
    let valueParams = "";



    try {
      decodedToken = this.helper.decodeToken(token);
      if (decodedToken != null) {
        profileUser = JSON.parse(decodedToken["Jwt"]);
      } else if (decodedToken == null) {
        return result;
      }

      if (params.country != null) {
        typeFilter = "country";
        valueParams = params.country;
        filterLocation = locations.filter(i => i.typeName == "Country");
      }
      if (params.zone != null) {
        typeFilter = "zone";
        valueParams = params.zone;
        filterLocation = locations.filter(i => i.typeName == "Zone");
      }
      if (params.service != null) {
        typeFilter = "service";
        valueParams = params.service;
        filterLocation = locations.filter(i => i.typeName == "Service");
      }
      if (params.sector != null) {
        typeFilter = "sector";
        valueParams = params.sector;
        filterLocation = locations.filter(i => i.typeName == "Sector");
      }


      filterLocation.forEach(element => {
        if (element[typeFilter].toUpperCase() == valueParams.toUpperCase()) {
          result = true
        }
      });

      profileUser.forEach(i => {
        if (i['profile'] == 'ADMINISTRADOR') {
          result = true;
        }
        // if (element['profile'] == 'Country Manager') {
        // }

      })





    } catch (e) {
      return result;
    }

    return result;
  }

  validateService(token: string, params: any) {
    return this.validateToken(this.userProfileStore.getUserProfile().token, params);
  }
}
